function waitForIframe() {
    const interval = setInterval(() => {
        const iframe = document.getElementById("klaviyo-bis-iframe");

        if (iframe) {
            clearInterval(interval);

            iframe.onload = function () {
                try {
                    const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;

                    const fontLink = document.createElement("link");
                    fontLink.href = "https://fonts.googleapis.com/css2?family=Nunito:ital,wght@0,400;0,500;0,800;1,400;1,800&display=swap";
                    fontLink.rel = "stylesheet";
                    iframeDocument.head.appendChild(fontLink);

                    const style = document.createElement("style");
                    style.textContent = `
                        #klaviyo-bis-modal #container {
                            font-family: "Nunito", helvetica, sans-serif !important;
                        }
                    `;
                    iframeDocument.head.appendChild(style);
                } catch (error) {
                    console.error("Cannot access iframe content");
                }
            };
        }
    }, 500);
}

waitForIframe();
